export default __webpack_public_path__ + "static/media/wing3.1adce522.png";